import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { ReviewCycleListItemFragmentDoc } from '../../fragment/generated/ReviewCycleListItem';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetReviewCycleListItemsQueryVariables = Types.Exact<{
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
  filters?: Types.InputMaybe<Types.ReviewCyclesFilters>;
}>;


export type GetReviewCycleListItemsQuery = { reviewCycles: { success: boolean, errorCode?: Types.PaginationErrorCodeEnum | null, totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, createdAt: string, updatedAt: string, title: string, startDate?: string | null, endDate?: string | null, status: Types.ReviewCycleStatusEnum, type: Types.ReviewCycleTypeEnum, completionPercentage?: number | null, createdBy?: { id: string, name?: string | null } | null, iconSettings?: { type: Types.IconTypeEnum, value: string } | null, reviewCycleEndSettings?: { cycleEndType: Types.ReviewCycleEndTypeEnum } | null, scheduleSettings?: { scheduleType: Types.ReviewCycleScheduleTypeEnum, recurringType?: Types.ReviewCycleRecurringTypeEnum | null } | null } }> | null } };


export const GetReviewCycleListItemsDocument = /*#__PURE__*/ gql`
    query getReviewCycleListItems($sort: [SortType!], $after: String, $first: Float, $filters: ReviewCyclesFilters) {
  reviewCycles(sort: $sort, after: $after, first: $first, filters: $filters) {
    pageInfo {
      hasNextPage
      endCursor
    }
    success
    errorCode
    totalCount
    edges {
      node {
        ...ReviewCycleListItem
      }
    }
  }
}
    ${ReviewCycleListItemFragmentDoc}`;

export function useGetReviewCycleListItemsQuery(options?: Omit<Urql.UseQueryArgs<GetReviewCycleListItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<GetReviewCycleListItemsQuery, GetReviewCycleListItemsQueryVariables>({ query: GetReviewCycleListItemsDocument, ...options });
};